import React from "react";

const Footer = () => {
  return (
    <div className="w-full text-center bg-gradient-to-b from-gray-800 to-gray-600 pb-1 text-white">
      Made with ❤️ by Kirthi Bagrecha Jain
    </div>
  );
};

export default Footer;
